module.exports = __webpack_public_path__ + "static/media/295584.85de426e.png";